/**
 * @param root0
 * @param root0.redirect
 * @param root0.store
 */
export default async function ({ redirect, store }) {
  if (store.getters["user/IS_INF"]) return redirect("/influencer/dashboard/")
  else if (store.getters["user/IS_BAND"]) return redirect("/band/homepage/")
  else await store.dispatch("tag/FETCH")
}
